export const filterIds = ['organization', 'customer'] as const;
